var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconJavascript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_857_76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0ZM29.38 24.37C29.146 22.906 28.192 21.682 25.375 20.537C24.396 20.079 23.302 19.756 22.979 19.016C22.859 18.578 22.838 18.339 22.916 18.078C23.119 17.213 24.135 16.958 24.937 17.198C25.458 17.359 25.937 17.755 26.239 18.396C27.619 17.495 27.619 17.495 28.578 16.896C28.219 16.339 28.042 16.094 27.797 15.86C26.958 14.917 25.839 14.438 24.021 14.48L23.078 14.6C22.177 14.819 21.318 15.298 20.797 15.939C19.281 17.658 19.719 20.658 21.557 21.903C23.375 23.262 26.036 23.559 26.38 24.841C26.698 26.404 25.219 26.904 23.755 26.721C22.677 26.481 22.078 25.94 21.416 24.94L18.978 26.341C19.254 26.982 19.577 27.258 20.056 27.82C22.374 30.159 28.176 30.039 29.217 26.481C29.253 26.361 29.535 25.538 29.316 24.283L29.38 24.37ZM17.401 14.708H14.406C14.406 17.291 14.39 19.859 14.39 22.448C14.39 24.089 14.473 25.599 14.208 26.063C13.765 26.98 12.635 26.865 12.119 26.704C11.593 26.444 11.322 26.084 11.015 25.563C10.926 25.422 10.864 25.303 10.843 25.303L8.411 26.803C8.817 27.642 9.411 28.366 10.177 28.824C11.318 29.506 12.849 29.725 14.453 29.366C15.495 29.064 16.396 28.444 16.864 27.486C17.546 26.246 17.4 24.726 17.395 23.022C17.411 20.282 17.395 17.543 17.395 14.782L17.401 14.708Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_857_76"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJavascript);
export default __webpack_public_path__ + "static/media/icon_javascript.71f2f07f3551ef9669e919fadb6a2803.svg";
export { ForwardRef as ReactComponent };